<script setup lang="ts">
import { computed, watch } from 'vue'
import AssetPreviewPage from '@/views/apps/assets/preview/AssetPreviewPage.vue'
import { useAssetStore } from '@/@vxapp/Assets/useAssetStore'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'

definePage({ meta: PageMeta.Assets.preview.meta })

const route = useRoute()

const assetsStore = useAssetStore() as unknown as {
  asset: { name?: string } | null
}

const assetGuid = computed(() => {
  const { guid } = route.params as unknown as { guid?: string | string[] }

  return Array.isArray(guid) ? (guid[0] ?? '') : (guid ?? '')
})

watch(
  () => assetsStore.asset,
  async newVal => {
    if (newVal?.name) setPageTitle(newVal.name)
  },
  { deep: true, immediate: false }
)

/* ** */
</script>

<template>
  <section>
    <!--
      Horizontal Menu / Navigation
      <VRow>
      <VCol cols="12">
      <HorizontalAssetsMenu/>
      </VCol>
      </VRow>
    -->

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <AssetPreviewPage :asset-g-u-i-d="assetGuid" />
      </VCol>
    </VRow>
  </section>
</template>
